import React, { useState, useEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { Plus, Save, Trash2, Info, ArrowLeft, Sparkles, Calendar, Users, Gift, Package, Layers, IndianRupee, FileText, ClipboardList, CheckSquare, Receipt } from "lucide-react";
import { showSuccessToast, showErrorToast } from "../../atoms/Utlis/Toast";
import { formatINR, formatTimeToAMPM } from "../../../Utils/helper";
import { getApiErrorMessage } from "../../atoms/Utlis/getApiErrorMessage";
import { useAppDispatch, useAppSelector } from "../../../Redux/Hooks";
import {
  getCustomersAPI,
  getEventTypesAPI,
  getProductsAPI,
  getEmployeesAPI,
  getFixChargesAPI,
  getAlbumTypesAPI,
  getAlbumPapersAPI,
} from "../../../Redux/ApiCalls/Dashboard/QuotationAPI";
import {
  createOrderAPI,
  getOrderByIdAPI,
  updateOrderAPI,
  getOrderNextNumberAPI,
} from "../../../Redux/ApiCalls/Dashboard/OrderAPI";
import { getUserCreatedEventsAPI } from "../../../Redux/ApiCalls/Dashboard/EventAPI";
import { countryCodes } from "../../../Utils/countryCodes";
import { EVENT_TYPE_LABELS } from "../../../Data/leads.dto";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import BrandDatePicker from "../../atoms/Utlis/BrandDatePicker";
import {
  cleanPhone,
  isSamePhone,
  FormSelect,
  TableSelect,
  PageContainer,
  FormScrollContainer,
  PageTitle,
  FormHero,
  FormHeroGlow,
  FormHeroRow,
  FormBackButton,
  FormHeroText,
  FormHeroBadge,
  FormHeroSubtitle,
  FormCard,
  SectionCard,
  SectionHeading,
  SectionIcon,
  SectionHeadingBody,
  SectionHeadingTitle,
  SectionHeadingSub,
  RowGrid,
  FormGroup,
  FormLabel,
  TextInput,
  TextAreaInput,
  DisabledInput,
  ManualCustomerCard,
  ComponentsSection,
  ComponentsBar,
  CheckboxLabel,
  TableWrap,
  DetailsTable,
  TableTextInput,
  TableNumberInput,
  ActionGroup,
  TableAddButton,
  TableDeleteButton,
  SizeX,
  ToggleSwitch,
  WithoutPriceBanner,
  WithoutPriceToggleWrapper,
  WithoutPriceText,
  WithoutPriceInfoBox,
  BottomSection,
  BottomColumn,
  GrandTotalDisplay,
  FooterButtonsRow,
  SubmitHint,
  SaveButton,
  BottomCheckboxes,
  Req,
  staticGifts,
  TableTimePickerWrapper,
} from "./formSharedStyles";
import { MarketplaceLoadingSpinner } from "./Marketplace/MarketplaceEmptyState";

const EndFooter = styled(FooterButtonsRow)`
  position: static;
  margin-top: 20px;
  margin-bottom: 8px;
`;



interface EventRow {
  id?: number;
  date: string;
  time: string;
  type: string;
  isCustomType?: boolean;
  customTypeVal?: string;
  isAddedRow?: boolean;
}

interface ResourceRow {
  id?: number;
  eventIndex: string; 
  resourceName: string;
  isCustomResource?: boolean;
  customResourceVal?: string;
  quantity: number | "";
  price: number | "";
}

interface GiftRow {
  id?: number;
  giftName: string;
  isCustomGift?: boolean;
  customGiftVal?: string;
  quantity: number | "";
}


const parsePhoneNumber = (fullPhone: string) => {
  const digits = fullPhone.replace(/\D/g, "");
  for (const c of countryCodes) {
    const stripped = c.code.replace("+", "");
    if (digits.startsWith(stripped) && digits.length > stripped.length) {
      return { code: c.code, phone: digits.slice(stripped.length) };
    }
  }
  return { code: "+91", phone: digits };
};

const CreateOrderForm: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const dispatch  = useAppDispatch();
  const queryParams = new URLSearchParams(location.search);
  const editId      = queryParams.get("id");

  
  const [dbCustomers, setDbCustomers] = useState<any[]>([]);
  const [dbEventTypes, setDbEventTypes] = useState<any[]>([]);
  const [dbProducts, setDbProducts] = useState<any[]>([]);
  const [dbEmployees, setDbEmployees] = useState<any[]>([]);
  const [dbFixCharges, setDbFixCharges] = useState<any[]>([]);
  const [dbAlbumTypes, setDbAlbumTypes] = useState<any[]>([]);
  const [dbAlbumPapers, setDbAlbumPapers] = useState<any[]>([]);
  const [dbEventInquiries, setDbEventInquiries] = useState<any[]>([]);
  const prefillDoneRef = useRef(false);

  // Country code dropdown state
  const [countryCode,          setCountryCode]          = useState("+91");
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [countrySearchQuery,   setCountrySearchQuery]   = useState("");
  const countryDropdownRef = useRef<HTMLDivElement>(null);

  
  const [orderNo,            setOrderNo]            = useState("");
  const [orderDate,          setOrderDate]          = useState("");
  const [selectedCustIndex,  setSelectedCustIndex]  = useState("custom");
  const [customerName,       setCustomerName]       = useState("");
  const [customerPhone,      setCustomerPhone]      = useState("");
  const [customerPlace,      setCustomerPlace]      = useState("");
  const [customerAddress,    setCustomerAddress]    = useState("");
  const [customerReference,  setCustomerReference]  = useState("");
  const [hasMatchedInquiry,  setHasMatchedInquiry]  = useState(false);

  
  const [addEventsChecked,           setAddEventsChecked]           = useState(true);
  const [addEventsResourcesChecked,  setAddEventsResourcesChecked]  = useState(true);
  const [addGiftsChecked,            setAddGiftsChecked]            = useState(false);
  const [addProductInfoChecked,      setAddProductInfoChecked]      = useState(false);
  const [addAlbumChecked,            setAddAlbumChecked]            = useState(false);
  const [addFixChargesChecked,       setAddFixChargesChecked]       = useState(false);
  const [withoutPriceChecked,        setWithoutPriceChecked]        = useState(false);
  const [addGstNumberChecked,        setAddGstNumberChecked]        = useState(false);
  const [addTermsChecked,            setAddTermsChecked]            = useState(true);
  const [termsText,                  setTermsText]                  = useState("");
  const [advancePaymentChecked,      setAdvancePaymentChecked]      = useState(false);
  const [whatsappConfirmChecked,     setWhatsappConfirmChecked]     = useState(false);
  const [isSaving,                   setIsSaving]                   = useState(false);
  const [loadingOrder,               setLoadingOrder]               = useState(Boolean(editId));

  const { business: authBusiness, user: authUser, branches, selectedBranch } = useAppSelector((state) => state.auth);
  const [selectedBranchId, setSelectedBranchId] = useState<string | number>(selectedBranch?.id || "");

  const activeBranch = useMemo(
    () => (branches || []).find((b) => String(b.id) === String(selectedBranchId)),
    [branches, selectedBranchId]
  );
  const studioGstNumber = (
    activeBranch?.gst_number ||
    (selectedBranch?.id && String(selectedBranch.id) === String(selectedBranchId) ? selectedBranch.gst_number : "") ||
    authBusiness?.gst_number ||
    (authUser as any)?.gst_number ||
    ""
  ).trim();

  const prevSelectedBranchIdRef = useRef<number | null | undefined>(selectedBranch?.id);
  const isOrderLoadedRef = useRef(false);

  useEffect(() => {
    if (prevSelectedBranchIdRef.current !== selectedBranch?.id) {
      prevSelectedBranchIdRef.current = selectedBranch?.id;
      if (!editId || isOrderLoadedRef.current) {
        setSelectedBranchId(selectedBranch?.id ? String(selectedBranch.id) : "");
      }
    }
  }, [selectedBranch?.id, editId]);

  const handleGstToggle = (checked: boolean) => {
    if (checked) {
      if (!studioGstNumber) {
        showErrorToast("Please add GST number in profile");
        setAddGstNumberChecked(false);
        return;
      }
      setAddGstNumberChecked(true);
    } else {
      setAddGstNumberChecked(false);
    }
  };

  
  const [eventRows,    setEventRows]    = useState<EventRow[]>([]);
  const [resourceRows, setResourceRows] = useState<ResourceRow[]>([]);
  const [giftRows,     setGiftRows]     = useState<GiftRow[]>([]);
  const [fixChargeRows,              setFixChargeRows]              = useState<any[]>([]);

  
  const [productInfoDescription, setProductInfoDescription] = useState("");

  
  const [albumType,            setAlbumType]            = useState("");
  const [isCustomAlbumType,    setIsCustomAlbumType]    = useState(false);
  const [customAlbumTypeVal,   setCustomAlbumTypeVal]   = useState("");
  const [albumWidth,           setAlbumWidth]           = useState(12);
  const [albumHeight,          setAlbumHeight]          = useState(18);
  const [albumPaper,           setAlbumPaper]           = useState("");
  const [isCustomAlbumPaper,   setIsCustomAlbumPaper]   = useState(false);
  const [customAlbumPaperVal,  setCustomAlbumPaperVal]  = useState("");
  const [albumPages,           setAlbumPages]           = useState(40);

  
  const [optAlbumPageCost,  setOptAlbumPageCost]  = useState("");
  const [optAlbumPagePrice, setOptAlbumPagePrice] = useState("");
  const [optVideoCost,      setOptVideoCost]      = useState("");
  const [optVideoPrice,     setOptVideoPrice]     = useState("");
  const [optPadPriceFrom,   setOptPadPriceFrom]   = useState("");
  const [optPadPriceTo,     setOptPadPriceTo]     = useState("");

  
  const [discountPercent, setDiscountPercent] = useState<number | "">("");
  const [taxPercent,      setTaxPercent]      = useState<number | "">("");

  
  const resourceOptions = useMemo(() => {
    const list: any[] = [];
    dbProducts.forEach((p) => {
      list.push({ id: p.id, name: p.name, type: "product", price: 0 });
    });
    dbEmployees.forEach((e) => {
      list.push({ id: e.id, name: e.name, type: "employee", price: 0 });
    });
    dbFixCharges.forEach((fc) => {
      list.push({ id: fc.id, name: fc.charge_name, type: "charge", price: fc.default_price });
    });
    return list;
  }, [dbProducts, dbEmployees, dbFixCharges]);

  // Close country dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target as Node)) {
        setIsCountryDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const hasInitializedDefaultsRef = useRef(false);

  useEffect(() => {
    if (authBusiness?.terms_and_conditions && !termsText && (!editId || !loadingOrder)) {
      setTermsText(authBusiness.terms_and_conditions);
    }
  }, [authBusiness?.terms_and_conditions, editId, loadingOrder, termsText]);

  useEffect(() => {
    const fetchAllPaginated = async (apiCallFn: (params: any) => Promise<any>, extraParams: Record<string, any> = {}): Promise<any[]> => {
      let all: any[] = [];
      let page = 1;
      let hasMore = true;
      while (hasMore) {
        const res = await apiCallFn({ page, page_size: 100, ...extraParams });
        const list = res?.results || (Array.isArray(res) ? res : []);
        all = [...all, ...list];
        if (res?.next && list.length === 100) {
          page += 1;
        } else {
          hasMore = false;
        }
      }
      return all;
    };

    const loadMasters = async () => {
      try {
        const branchParam = selectedBranchId ? { branch_id: Number(selectedBranchId) } : {};
        const [custsList, evTypesList, prodsList, empsList, chargesList, albTypesList, albPapersList, evInqs] = await Promise.all([
          fetchAllPaginated(getCustomersAPI, branchParam),
          fetchAllPaginated(getEventTypesAPI, branchParam),
          fetchAllPaginated(getProductsAPI, branchParam),
          fetchAllPaginated(getEmployeesAPI, branchParam),
          fetchAllPaginated(getFixChargesAPI, branchParam),
          fetchAllPaginated(getAlbumTypesAPI, branchParam),
          fetchAllPaginated(getAlbumPapersAPI, branchParam),
          dispatch(getUserCreatedEventsAPI(branchParam)).unwrap(),
        ]);

        const evInqsList = Array.isArray(evInqs) ? evInqs : [];

        setDbCustomers((prev) => {
          const merged = [...custsList];
          prev.forEach((c) => {
            if (c && c.id && !merged.some((m) => m.id === c.id)) merged.push(c);
          });
          return merged;
        });
        setDbEventTypes((prev) => {
          const merged = [...evTypesList];
          prev.forEach((et) => {
            if (et && et.name && !merged.some((m) => m.name === et.name)) merged.push(et);
          });
          return merged;
        });
        setDbProducts(prodsList);
        setDbEmployees(empsList);
        setDbFixCharges(chargesList);
        setDbAlbumTypes(albTypesList);
        setDbAlbumPapers(albPapersList);
        setDbEventInquiries(evInqsList);

        
        if (!editId && !hasInitializedDefaultsRef.current) {
          hasInitializedDefaultsRef.current = true;
          if (location.state?.leadData) {
            const lead = location.state.leadData;
            const mappedType = lead.event_type ? (EVENT_TYPE_LABELS[lead.event_type as keyof typeof EVENT_TYPE_LABELS] || lead.event_type) : (evTypesList[0]?.name || "");
            setEventRows([{ date: lead.event_date || "", time: formatTimeToAMPM(lead.event_time), type: mappedType }]);
          } else {
            const defaultType = evTypesList.length > 0 ? evTypesList[0].name : "";
            setEventRows([{ date: "", time: "", type: defaultType, isCustomType: evTypesList.length === 0 }]);
          }


          const firstProd = prodsList.length > 0 ? prodsList[0].name : "";
          setResourceRows([{ eventIndex: "0", resourceName: firstProd, quantity: 1, price: "" }]);

          setGiftRows([{ giftName: staticGifts[0], quantity: 1 }]);

          if (albTypesList.length > 0) setAlbumType(albTypesList[0].name);
          if (albPapersList.length > 0) setAlbumPaper(albPapersList[0].name);
        }
      } catch (err) {
        showErrorToast("Failed to load helper masters datasets from backend");
      }
    };
    loadMasters();
  }, [dispatch, editId, staticGifts, selectedBranchId]);

  
  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0]; 
    setOrderDate(formattedToday);

    const loadOrderData = async () => {
      if (editId) {
        setLoadingOrder(true);
        try {
          const record = await getOrderByIdAPI(editId);
          if (record) {
            setOrderNo(record.order_no);
            setOrderDate(record.order_date);
            if (record.branch_id) {
              setSelectedBranchId(String(record.branch_id));
            } else {
              setSelectedBranchId("");
            }
            isOrderLoadedRef.current = true;
            prevSelectedBranchIdRef.current = selectedBranch?.id;
            setCustomerName(record.customer_name || "");
            const parsedPhone = parsePhoneNumber(cleanPhone(record.customer_phone || ""));
            setCountryCode(parsedPhone.code);
            setCustomerPhone(parsedPhone.phone);
            setCustomerPlace(record.customer_place || "");
            setCustomerAddress(record.customer_address || "");
            setCustomerReference(record.customer_reference || "");

            if (record.customer) {
              const custObj = typeof record.customer === "object" ? record.customer : null;
              const custId = custObj ? custObj.id : record.customer;
              if (custObj) {
                setDbCustomers((prev) => {
                  if (!prev.some((c) => c.id === custObj.id)) {
                    const cleanObj = { ...custObj, phone: cleanPhone(custObj.phone || "") };
                    return [...prev, cleanObj];
                  }
                  return prev;
                });
              } else {
                setDbCustomers((prev) => {
                  if (!prev.some((c) => c.id === custId)) {
                    return [...prev, {
                      id: custId,
                      name: record.customer_name || "Unknown Customer",
                      phone: cleanPhone(record.customer_phone || ""),
                      place: record.customer_place || "",
                      address: record.customer_address || "",
                      reference: record.customer_reference || ""
                    }];
                  }
                  return prev;
                });
              }
              setSelectedCustIndex(String(custId));
            } else {
              setSelectedCustIndex("custom");
            }

            setAddEventsChecked(record.add_events);
            setAddEventsResourcesChecked(record.add_events_resources);
            setAddGiftsChecked(record.add_gifts);
            setAddProductInfoChecked(record.add_product_info);
            setAddAlbumChecked(record.add_album);
            setAddFixChargesChecked(record.add_fix_charges || false);
            setWithoutPriceChecked(record.without_price);
            setAddGstNumberChecked(Boolean(record.add_gst_number));
            const hasTerms = record.add_terms_conditions !== undefined && record.add_terms_conditions !== null
              ? Boolean(record.add_terms_conditions)
              : false;
            setAddTermsChecked(hasTerms);
            if (record.terms_and_conditions && typeof record.terms_and_conditions === "string" && record.terms_and_conditions.trim()) {
              setTermsText(record.terms_and_conditions);
            } else if (authBusiness?.terms_and_conditions && authBusiness.terms_and_conditions.trim()) {
              setTermsText(authBusiness.terms_and_conditions);
            } else {
              setTermsText("");
            }
            setAdvancePaymentChecked(record.advance_payment);
            setWhatsappConfirmChecked(record.whatsapp_confirm);
            setProductInfoDescription(record.product_info_description || "");

            setDiscountPercent(Number(record.discount_percent) || 0);
            setTaxPercent(Number(record.tax_percent) || 0);

            if (record.events && record.events.length > 0) {
              setEventRows(
                record.events.map((e: any) => ({
                  id: e.id,
                  date: e.event_date,
                  time: formatTimeToAMPM(e.event_time),
                  type: e.event_type || e.event_type_name || "",
                }))
              );
            }
            if (record.resources && record.resources.length > 0) {
              setResourceRows(
                record.resources.map((r: any) => {
                  let eventIndex = "all";
                  if (r.event !== null && record.events) {
                    const idx = record.events.findIndex((evt: any) => evt.id === r.event);
                    if (idx !== -1) eventIndex = String(idx);
                  }
                  return {
                    id: r.id,
                    eventIndex,
                    resourceName: r.resource_name,
                    quantity: r.quantity,
                    price: Number(r.unit_price) || 0,
                  };
                })
              );
            }
            if (record.gifts && record.gifts.length > 0) {
              setGiftRows(
                record.gifts.map((g: any) => {
                  const isCustom = !staticGifts.includes(g.gift_name);
                  return {
                    id: g.id,
                    giftName: g.gift_name,
                    quantity: g.quantity,
                    isCustomGift: isCustom,
                    customGiftVal: isCustom ? g.gift_name : undefined,
                  };
                })
              );
            }
            if (record.fix_charge_items && record.fix_charge_items.length > 0) {
              setFixChargeRows(
                record.fix_charge_items.map((fc: any) => ({
                  id: fc.id,
                  chargeName: fc.charge_name,
                  quantity: fc.quantity,
                  price: Number(fc.unit_price) || 0,
                }))
              );
            }
            if (record.album_detail) {
              const alb = record.album_detail;
              setAlbumType(alb.album_type_name || "");
              setAlbumWidth(Number(alb.album_width) || 12);
              setAlbumHeight(Number(alb.album_height) || 18);
              setAlbumPaper(alb.album_paper_name || "");
              setAlbumPages(alb.album_pages || 40);
              setOptAlbumPageCost(alb.opt_album_page_cost || "");
              setOptAlbumPagePrice(alb.opt_album_page_price || "");
              setOptVideoCost(alb.opt_video_cost || "");
              setOptVideoPrice(alb.opt_video_price || "");
              setOptPadPriceFrom(alb.opt_pad_price_from || "");
              setOptPadPriceTo(alb.opt_pad_price_to || "");
            }
          }
        } catch (err) {
          showErrorToast("Failed to fetch order details for editing");
        } finally {
          setLoadingOrder(false);
        }
      } else {
        try {
          const nextVal = await getOrderNextNumberAPI();
          if (nextVal && nextVal.next_order_no) {
            setOrderNo(nextVal.next_order_no);
          }
        } catch {
        }
        if (location.state?.leadData) {
          const lead = location.state.leadData;
          setCustomerName(lead.name || "");
          const parsedLeadPhone = parsePhoneNumber(cleanPhone(lead.phone || ""));
          setCountryCode(parsedLeadPhone.code);
          setCustomerPhone(parsedLeadPhone.phone);
          setCustomerPlace(lead.venue_city || "");
          setCustomerReference(lead.source ? `Lead: ${lead.source}` : "");
        }
      }
    };
    loadOrderData();
  }, [editId, location.state]);


  
  useEffect(() => {
    if (editId && resourceOptions.length > 0 && resourceRows.length > 0) {
      const needsUpdate = resourceRows.some((r) => r.isCustomResource === undefined);
      if (needsUpdate) {
        setResourceRows((prev) =>
          prev.map((row) => {
            if (row.isCustomResource !== undefined) return row;
            const isKnown = resourceOptions.some((opt) => opt.name === row.resourceName);
            const isCustom = !isKnown;
            return {
              ...row,
              isCustomResource: isCustom,
              customResourceVal: isCustom ? row.resourceName : undefined
            };
          })
        );
      }
    }
  }, [editId, resourceOptions, resourceRows]);

  
  useEffect(() => {
    if (editId && dbEventTypes.length > 0 && eventRows.length > 0) {
      const needsUpdate = eventRows.some(
        (e) => e.isCustomType === undefined || /^\d+$/.test(e.type)
      );
      if (needsUpdate) {
        setEventRows((prev) =>
          prev.map((row) => {
            let currentType = row.type;
            const matchedById = dbEventTypes.find((et) => String(et.id) === String(currentType));
            if (matchedById) {
              currentType = matchedById.name;
            }
            
            const isKnown = dbEventTypes.some((et) => et.name === currentType);
            const isCustom = !isKnown;
            return {
              ...row,
              type: currentType,
              isCustomType: isCustom,
              customTypeVal: isCustom ? currentType : undefined
            };
          })
        );
      }
    }
  }, [editId, dbEventTypes, eventRows]);

  useEffect(() => {
    if (editId && dbFixCharges.length > 0 && fixChargeRows.length > 0) {
      const needsUpdate = fixChargeRows.some((fc) => fc.isCustomCharge === undefined);
      if (needsUpdate) {
        setFixChargeRows((prev) =>
          prev.map((row) => {
            if (row.isCustomCharge !== undefined) return row;
            const isKnown = dbFixCharges.some((fc) => fc.charge_name === row.chargeName);
            return {
              ...row,
              isCustomCharge: !isKnown,
              customChargeVal: !isKnown ? row.chargeName : undefined,
            };
          })
        );
      }
    }
  }, [editId, dbFixCharges, fixChargeRows]);

  useEffect(() => {
    if (addFixChargesChecked && fixChargeRows.length === 0) {
      const defaultName = dbFixCharges && dbFixCharges.length > 0 ? dbFixCharges[0].charge_name : "";
      const defaultPrice = dbFixCharges && dbFixCharges.length > 0 ? (Number(dbFixCharges[0].default_price) || "") : "";
      const isCustom = dbFixCharges.length === 0;
      setFixChargeRows([
        { chargeName: defaultName, quantity: 1, price: defaultPrice, isCustomCharge: isCustom }
      ]);
    }
  }, [addFixChargesChecked, fixChargeRows.length, dbFixCharges]);

  useEffect(() => {
    if (dbAlbumTypes.length > 0) {
      if (!albumType) {
        if (!isCustomAlbumType) {
          setAlbumType(dbAlbumTypes[0].name);
        }
      } else {
        const match = dbAlbumTypes.find((at) => at.name === albumType);
        if (!match) {
          if (!isCustomAlbumType) {
            setIsCustomAlbumType(true);
          }
          if (customAlbumTypeVal !== albumType) {
            setCustomAlbumTypeVal(albumType);
          }
        } else {
          if (isCustomAlbumType) {
            setIsCustomAlbumType(false);
          }
        }
      }
    }
  }, [dbAlbumTypes, albumType]);

  useEffect(() => {
    if (dbAlbumPapers.length > 0) {
      if (!albumPaper) {
        if (!isCustomAlbumPaper) {
          setAlbumPaper(dbAlbumPapers[0].name);
        }
      } else {
        const match = dbAlbumPapers.find((ap) => ap.name === albumPaper);
        if (!match) {
          if (!isCustomAlbumPaper) {
            setIsCustomAlbumPaper(true);
          }
          if (customAlbumPaperVal !== albumPaper) {
            setCustomAlbumPaperVal(albumPaper);
          }
        } else {
          if (isCustomAlbumPaper) {
            setIsCustomAlbumPaper(false);
          }
        }
      }
    }
  }, [dbAlbumPapers, albumPaper]);


  useEffect(() => {
    if (!editId && location.state?.leadData && dbCustomers.length > 0 && dbEventTypes.length > 0 && !prefillDoneRef.current) {
      prefillDoneRef.current = true;
      const lead = location.state.leadData;
      const cleanLeadPhone = cleanPhone(lead.phone || "");
      const matchedCust = dbCustomers.find(c => isSamePhone(c.phone, lead.phone));
      
      if (matchedCust) {
        setSelectedCustIndex(String(matchedCust.id));
        setCustomerName(matchedCust.name);
        setCustomerPhone(cleanPhone(matchedCust.phone));
        setCustomerPlace(matchedCust.place || "");
        setCustomerAddress(matchedCust.address || "");
        setCustomerReference(matchedCust.reference || "");
        
        const normalizedPhone = matchedCust.phone.replace(/[\s+\-()]/g, "").slice(-10);
        const inquiryWrapper = dbEventInquiries.find((item) => {
          const inqPhone = (item.event?.phone_number || "").replace(/[\s+\-()]/g, "").slice(-10);
          return inqPhone && inqPhone === normalizedPhone;
        });

        if (inquiryWrapper && inquiryWrapper.sub_events && inquiryWrapper.sub_events.length > 0) {
          setHasMatchedInquiry(true);
          const mappedSubEvents = inquiryWrapper.sub_events.map((se: any) => {
            const matchedType = dbEventTypes.find((et) => et.name.toLowerCase().trim() === se.sub_event_name.toLowerCase().trim());
            return {
              date: se.starting_date || "",
              time: formatTimeToAMPM(se.starting_time),
              type: matchedType ? matchedType.name : (se.sub_event_name ? se.sub_event_name.trim() : ""),
              isCustomType: !matchedType,
              customTypeVal: !matchedType ? se.sub_event_name : undefined,
              isAddedRow: false
            };
          });
          setEventRows(mappedSubEvents);
          return;
        }
      }
      
      const mappedType = lead.event_type ? (EVENT_TYPE_LABELS[lead.event_type as keyof typeof EVENT_TYPE_LABELS] || lead.event_type) : (dbEventTypes[0]?.name || "");
      const matchedType = dbEventTypes.find((et) => et.name.toLowerCase().trim() === mappedType.toLowerCase().trim());
      setEventRows([{
        date: lead.event_date || "",
        time: formatTimeToAMPM(lead.event_time),
        type: matchedType ? matchedType.name : mappedType,
        isCustomType: !matchedType,
        customTypeVal: !matchedType ? mappedType : undefined,
        isAddedRow: false
      }]);
    }
  }, [editId, location.state, dbCustomers, dbEventTypes, dbEventInquiries]);

  useEffect(() => {
    if (addEventsChecked && eventRows.length === 0) {
      const defaultType = dbEventTypes.length > 0 ? dbEventTypes[0].name : "";
      setEventRows([{ date: "", time: "", type: defaultType, isCustomType: dbEventTypes.length === 0, isAddedRow: true }]);
    }
  }, [addEventsChecked, eventRows.length, dbEventTypes]);

  useEffect(() => {
    if (addEventsResourcesChecked && resourceRows.length === 0) {
      const firstProd = dbProducts.length > 0 ? dbProducts[0].name : "";
      setResourceRows([{ eventIndex: "0", resourceName: firstProd, quantity: 1, price: "" }]);
    }
  }, [addEventsResourcesChecked, resourceRows.length, dbProducts]);

  useEffect(() => {
    if (addGiftsChecked && giftRows.length === 0) {
      setGiftRows([{ giftName: staticGifts[0], quantity: 1 }]);
    }
  }, [addGiftsChecked, giftRows.length]);


  
  const handleCustChange = (e: { target: { value: string } }) => {
    const val = e.target.value;
    setSelectedCustIndex(val);
    if (val === "custom") {
      setCustomerName("");
      setCustomerPhone("");
      setCustomerPlace("");
      setCustomerAddress("");
      setCustomerReference("");
      setHasMatchedInquiry(false);
      const defaultType = dbEventTypes && dbEventTypes.length > 0 ? dbEventTypes[0].name : "";
      setEventRows([{ date: "", time: "", type: defaultType, isCustomType: dbEventTypes && dbEventTypes.length === 0, isAddedRow: true }]);
      setResourceRows([
        { eventIndex: "0", resourceName: dbProducts && dbProducts.length > 0 ? dbProducts[0].name : "", quantity: 1, price: "" }
      ]);
    } else {
      const match = dbCustomers.find((c) => String(c.id) === String(val));
      if (match) {
        setCustomerName(match.name);
        const parsedMatchPhone = parsePhoneNumber(cleanPhone(match.phone));
        setCountryCode(parsedMatchPhone.code);
        setCustomerPhone(parsedMatchPhone.phone);
        setCustomerPlace(match.place || "");
        setCustomerAddress(match.address || "");
        setCustomerReference(match.reference || "");


        
        const normalizedPhone = match.phone.replace(/[\s+\-()]/g, "").slice(-10);
        const inquiryWrapper = dbEventInquiries.find((item) => {
          const inqPhone = (item.event?.phone_number || "").replace(/[\s+\-()]/g, "").slice(-10);
          return inqPhone && inqPhone === normalizedPhone;
        });

        if (inquiryWrapper) {
          setHasMatchedInquiry(true);
          const mainEventName = inquiryWrapper.event?.event_name || "";
          if (inquiryWrapper.sub_events && inquiryWrapper.sub_events.length > 0) {
            const mappedSubEvents = inquiryWrapper.sub_events.map((se: any) => {
              const matchedType = dbEventTypes.find((et) => et.name.toLowerCase().trim() === se.sub_event_name.toLowerCase().trim());
              return {
                date: se.starting_date || "",
                time: formatTimeToAMPM(se.starting_time),
                type: matchedType ? matchedType.name : (se.sub_event_name ? se.sub_event_name.trim() : ""),
                isCustomType: !matchedType,
                customTypeVal: !matchedType ? se.sub_event_name : undefined,
                isAddedRow: false
              };
            });
            setEventRows(mappedSubEvents);
            setResourceRows([
              { eventIndex: "0", resourceName: dbProducts.length > 0 ? dbProducts[0].name : "", quantity: 1, price: "" }
            ]);
          } else if (mainEventName) {
            const matchedType = dbEventTypes.find((et) => et.name.toLowerCase().trim() === mainEventName.toLowerCase().trim());
            setEventRows([{
              date: "",
              time: "",
              type: matchedType ? matchedType.name : (mainEventName ? mainEventName.trim() : ""),
              isCustomType: !matchedType,
              customTypeVal: !matchedType ? mainEventName : undefined,
              isAddedRow: false
            }]);
            setResourceRows([
              { eventIndex: "0", resourceName: dbProducts.length > 0 ? dbProducts[0].name : "", quantity: 1, price: "" }
            ]);
          } else {
            const defaultType = dbEventTypes.length > 0 ? dbEventTypes[0].name : "";
            setEventRows([{ date: "", time: "", type: defaultType, isCustomType: dbEventTypes.length === 0, isAddedRow: true }]);
            setResourceRows([
              { eventIndex: "0", resourceName: dbProducts.length > 0 ? dbProducts[0].name : "", quantity: 1, price: "" }
            ]);
          }
        } else {
          setHasMatchedInquiry(false);
          const defaultType = dbEventTypes.length > 0 ? dbEventTypes[0].name : "";
          setEventRows([{ date: "", time: "", type: defaultType, isCustomType: dbEventTypes.length === 0, isAddedRow: true }]);
          setResourceRows([
            { eventIndex: "0", resourceName: dbProducts.length > 0 ? dbProducts[0].name : "", quantity: 1, price: "" }
          ]);
        }
      }
    }
  };

  
  const addEventRow = () => {
    const defaultType = dbEventTypes.length > 0 ? dbEventTypes[0].name : "";
    setEventRows([...eventRows, { date: "", time: "", type: defaultType, isCustomType: dbEventTypes.length === 0, isAddedRow: true }]);
  };
  const removeEventRow = (idx: number) => {
    const updated = eventRows.filter((_, i) => i !== idx);
    setEventRows(updated);

    const updatedResources = resourceRows
      .filter((res) => {
        if (res.eventIndex === "all") return true;
        const rIdx = parseInt(res.eventIndex, 10);
        return rIdx !== idx;
      })
      .map((res) => {
        if (res.eventIndex === "all") return res;
        const rIdx = parseInt(res.eventIndex, 10);
        if (rIdx > idx) return { ...res, eventIndex: String(rIdx - 1) };
        return res;
      });
    setResourceRows(updatedResources);

    if (updated.length === 0) {
      setAddEventsChecked(false);
    }
  };
  const updateEventRow = (idx: number, field: keyof EventRow, val: any) => {
    setEventRows((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [field]: val };
      return updated;
    });
  };

  
  const addResourceRowForEvent = (eventIndex: string) => {
    const defaultRes = resourceOptions.length > 0 ? resourceOptions[0].name : "";
    const defaultPrice = resourceOptions.length > 0 ? (resourceOptions[0].price || "") : "";
    const isCustom = resourceOptions.length === 0;
    setResourceRows((prev) => [
      ...prev,
      {
        eventIndex,
        resourceName: defaultRes,
        quantity: 1,
        price: defaultPrice,
        isCustomResource: isCustom,
      },
    ]);
  };

  const resourceGroups = useMemo(() => {
    if (!addEventsChecked || eventRows.length === 0) {
      return [
        {
          key: "all",
          eventIndex: "all",
          label: null as string | null,
          indices: resourceRows.map((_, i) => i),
        },
      ];
    }
    const groups = eventRows.map((evt, eIdx) => ({
      key: String(eIdx),
      eventIndex: String(eIdx),
      label: `Event ${eIdx + 1}: ${evt.type || "Untitled"} (${evt.date || "No Date"})`,
      indices: resourceRows
        .map((r, i) => (r.eventIndex === String(eIdx) ? i : -1))
        .filter((i) => i >= 0),
    }));
    const allEventIndices = resourceRows
      .map((r, i) => (r.eventIndex === "all" ? i : -1))
      .filter((i) => i >= 0);
    if (allEventIndices.length > 0) {
      groups.push({
        key: "all",
        eventIndex: "all",
        label: "All Events",
        indices: allEventIndices,
      });
    }
    return groups;
  }, [addEventsChecked, eventRows, resourceRows]);

  const showResourceEventGroups = addEventsChecked && eventRows.length > 0;
  const resourceColumnCount = showResourceEventGroups
    ? withoutPriceChecked
      ? 3
      : 5
    : withoutPriceChecked
      ? 4
      : 6;

  const removeResourceRow = (idx: number) => {
    const updated = resourceRows.filter((_, i) => i !== idx);
    setResourceRows(updated);
    if (updated.length === 0) {
      setAddEventsResourcesChecked(false);
    }
  };
  const updateResourceRow = (idx: number, field: keyof ResourceRow, val: any) => {
    setResourceRows((prev) => {
      const updated = [...prev];
      if (!updated[idx]) return prev;

      if (field === "isCustomResource") {
        const isCustom = Boolean(val);
        updated[idx] = {
          ...updated[idx],
          isCustomResource: isCustom,
          resourceName: isCustom ? (updated[idx].customResourceVal || "") : updated[idx].resourceName,
        };
      } else if (field === "resourceName") {
        const isCustom = val === "custom";
        if (isCustom) {
          updated[idx] = {
            ...updated[idx],
            isCustomResource: true,
            resourceName: updated[idx].customResourceVal || "",
          };
        } else {
          const item = resourceOptions.find((r) => r.name === val);
          updated[idx] = {
            ...updated[idx],
            isCustomResource: false,
            resourceName: val,
            price: item ? (Math.max(0, Number(item.price)) || "") : (updated[idx].price || ""),
          };
        }
      } else if (field === "customResourceVal") {
        updated[idx] = {
          ...updated[idx],
          isCustomResource: true,
          customResourceVal: val,
          resourceName: val,
        };
      } else if (field === "price") {
        const numericVal = val === "" ? "" : Math.max(0, Number(val));
        updated[idx] = { ...updated[idx], price: numericVal };
      } else {
        updated[idx] = { ...updated[idx], [field]: val };
      }
      return updated;
    });
  };

  
  const addGiftRow    = () => setGiftRows([...giftRows, { giftName: staticGifts[0], quantity: 1 }]);
  const removeGiftRow = (idx: number) => {
    const updated = giftRows.filter((_, i) => i !== idx);
    setGiftRows(updated);
    if (updated.length === 0) {
      setAddGiftsChecked(false);
    }
  };
  const updateGiftRow = (idx: number, field: keyof GiftRow, val: any) => {
    setGiftRows((prev) => {
      const updated = [...prev];
      if (field === "isCustomGift") {
        updated[idx].isCustomGift = val;
      } else if (field === "giftName") {
        updated[idx].giftName     = val;
      } else {
        updated[idx] = { ...updated[idx], [field]: val };
      }
      return updated;
    });
  };

  const addFixChargeRow = () => {
    const defaultChargeName = dbFixCharges && dbFixCharges.length > 0 ? dbFixCharges[0].charge_name : "";
    const defaultChargePrice = dbFixCharges && dbFixCharges.length > 0 ? (Number(dbFixCharges[0].default_price) || "") : "";
    setFixChargeRows((prev) => [
      ...prev,
      { chargeName: defaultChargeName, quantity: 1, price: defaultChargePrice, isCustomCharge: false }
    ]);
  };

  const updateFixChargeRow = (idx: number, field: string, val: any) => {
    setFixChargeRows((prev) => {
      const updated = [...prev];
      if (field === "chargeName" && !updated[idx].isCustomCharge) {
        const item = dbFixCharges.find((f) => f.charge_name === val);
        updated[idx] = {
          ...updated[idx],
          chargeName: val,
          price: item ? (Number(item.default_price) || 0) : 0
        };
      } else {
        updated[idx] = { ...updated[idx], [field]: val };
      }
      return updated;
    });
  };

  const removeFixChargeRow = (idx: number) => {
    const updated = fixChargeRows.filter((_, i) => i !== idx);
    setFixChargeRows(updated);
    if (updated.length === 0) {
      setAddFixChargesChecked(false);
    }
  };

  const pricing = useMemo(() => {
    if (withoutPriceChecked) return { totalAmount: 0, discountAmount: 0, subtotal: 0, taxAmount: 0, grandTotal: 0 };
    let resourcesSum = 0;
    if (addEventsResourcesChecked) {
      resourcesSum = resourceRows.reduce((s, r) => s + (Number(r.price) || 0) * (Number(r.quantity) || 0), 0);
    }
    let fixChargesSum = 0;
    if (addFixChargesChecked) {
      fixChargesSum = fixChargeRows.reduce((s, fc) => s + (Number(fc.price) || 0) * (Number(fc.quantity) || 0), 0);
    }
    const totalAmount   = resourcesSum + fixChargesSum;
    const discountAmt   = (totalAmount * (Number(discountPercent) || 0)) / 100;
    const subtotal      = totalAmount - discountAmt;
    const taxAmt        = (subtotal * (Number(taxPercent) || 0)) / 100;
    return { totalAmount, discountAmount: discountAmt, subtotal, taxAmount: taxAmt, grandTotal: subtotal + taxAmt };
  }, [resourceRows, fixChargeRows, discountPercent, taxPercent, addEventsResourcesChecked, addFixChargesChecked, withoutPriceChecked]);

  
  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true);
    if (!customerName.trim()) { showErrorToast("Customer name is required"); setIsSaving(false); return; }
    if (!customerPhone.trim()) { showErrorToast("Customer phone is required"); setIsSaving(false); return; }

    let finalPhone = customerPhone.trim();
    if (selectedCustIndex === "custom") {
      const strippedCode = countryCode.replace("+", "");
      if (!finalPhone.startsWith(strippedCode)) {
        finalPhone = strippedCode + finalPhone;
      }
      if (!/^\d{10,15}$/.test(finalPhone)) {
        showErrorToast("Please enter a valid mobile number");
        return;
      }
    }

    const formattedEvents = eventRows.map((e, idx) => ({
      id: e.id,
      event_date: e.date || "",
      event_time: e.time ? formatTimeToAMPM(e.time) : "",
      event_type: e.isCustomType ? (e.customTypeVal || e.type) : e.type,
      order_index: idx
    }));

    const formattedResources = resourceRows.map((r, idx) => {
      let linkedEvent = null;
      if (r.eventIndex !== "all" && r.eventIndex !== "") {
        const linkedIdx = parseInt(r.eventIndex);
        if (!isNaN(linkedIdx) && formattedEvents[linkedIdx]) {
          linkedEvent = linkedIdx; 
        }
      }
      return {
        id: r.id,
        event: linkedEvent,
        resource_name: r.isCustomResource ? (r.customResourceVal || r.resourceName) : r.resourceName,
        quantity: Number(r.quantity) || 1,
        unit_price: Number(r.price) || 0,
        order_index: idx
      };
    });

    const formattedGifts = giftRows.map((g, idx) => ({
      id: g.id,
      gift_name: g.isCustomGift ? (g.customGiftVal || g.giftName) : g.giftName,
      quantity: Number(g.quantity) || 1,
      order_index: idx
    }));

    const formattedFixCharges = addFixChargesChecked
      ? fixChargeRows.map((row, orderIdx) => {
          const match = dbFixCharges.find((fc) => fc.charge_name === row.chargeName);
          return {
            id: row.id,
            fix_charge: match ? match.id : null,
            charge_name: row.chargeName,
            quantity: Number(row.quantity) || 1,
            unit_price: Number(row.price) || 0,
            order_index: orderIdx,
          };
        })
      : [];

    const payload: any = {
      branch_id: selectedBranchId ? Number(selectedBranchId) : null,
      order_no: orderNo,
      order_date: orderDate,
      customer: selectedCustIndex === "custom" ? null : parseInt(selectedCustIndex),
      customer_name: customerName,
      customer_phone: finalPhone,
      customer_place: customerPlace,
      customer_address: customerAddress,
      customer_reference: customerReference,
      status: "Active",
      add_events: addEventsChecked,
      add_events_resources: addEventsResourcesChecked,
      add_gifts: addGiftsChecked,
      add_product_info: addProductInfoChecked,
      add_album: addAlbumChecked,
      add_fix_charges: addFixChargesChecked,
      without_price: withoutPriceChecked,
      add_gst_number: addGstNumberChecked,
      gst_number: addGstNumberChecked ? (studioGstNumber || "") : "",
      add_terms_conditions: addTermsChecked,
      terms_and_conditions: addTermsChecked ? (termsText || authBusiness?.terms_and_conditions || null) : null,
      advance_payment: advancePaymentChecked,
      whatsapp_confirm: whatsappConfirmChecked,
      product_info_description: productInfoDescription,
      discount_percent: String(discountPercent || 0),
      tax_percent: String(taxPercent || 0),
      events: formattedEvents,
      resources: formattedResources,
      gifts: formattedGifts,
      fix_charge_items: formattedFixCharges,
    };

    if (addAlbumChecked) {
      payload.album_detail = {
        album_type_name: isCustomAlbumType ? (customAlbumTypeVal || albumType) : albumType,
        album_width: String(albumWidth),
        album_height: String(albumHeight),
        album_paper_name: isCustomAlbumPaper ? (customAlbumPaperVal || albumPaper) : albumPaper,
        album_pages: albumPages,
        opt_album_page_cost: optAlbumPageCost,
        opt_album_page_price: String(optAlbumPagePrice || 0),
        opt_video_cost: optVideoCost,
        opt_video_price: String(optVideoPrice || 0),
        opt_pad_price_from: String(optPadPriceFrom || 0),
        opt_pad_price_to: String(optPadPriceTo || 0),
      };
    }

    try {
      if (editId) {
        await updateOrderAPI(editId, payload);
        showSuccessToast("Order updated successfully!");
      } else {
        await dispatch(createOrderAPI(payload)).unwrap();
        showSuccessToast("Order created successfully!");
      }
      navigate("/dashboard/orders");
    } catch (err: any) {
      showErrorToast(getApiErrorMessage(err, "Failed to save order"));
    } finally {
      setIsSaving(false);
    }
  };

  if (editId && loadingOrder) {
    return (
      <PageContainer>
        <MarketplaceLoadingSpinner padding="80px 0" />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <FormHero>
        <FormHeroGlow />
        <FormHeroRow>
          <FormBackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
            <ArrowLeft size={18} />
          </FormBackButton>
          <FormHeroText>
            <FormHeroBadge>
              <Sparkles size={11} />
              Orders
            </FormHeroBadge>
            <PageTitle className="linear-text">
              {editId ? "Edit Order" : "Add Order"}
            </PageTitle>
            <FormHeroSubtitle>
              {editId
                ? "Update customer details, events, resources, and pricing for this order."
                : "Build an order with events, resources, albums, and optional pricing."}
            </FormHeroSubtitle>
          </FormHeroText>
        </FormHeroRow>
      </FormHero>

      <FormScrollContainer>
        <FormCard>
          <WithoutPriceBanner>
            <WithoutPriceToggleWrapper>
              <WithoutPriceText>Create order without price</WithoutPriceText>
              <ToggleSwitch>
                <input
                  type="checkbox"
                  checked={withoutPriceChecked}
                  onChange={(e) => setWithoutPriceChecked(e.target.checked)}
                />
                <span />
              </ToggleSwitch>
            </WithoutPriceToggleWrapper>

            <WithoutPriceInfoBox>
              <Info size={18} color="#c94daa" />
              <span>Hides price and amount fields. You can add them later when ready.</span>
            </WithoutPriceInfoBox>
          </WithoutPriceBanner>

          <WithoutPriceBanner style={{ marginTop: "-8px" }}>
            <WithoutPriceToggleWrapper>
              <WithoutPriceText>Add GST number</WithoutPriceText>
              <ToggleSwitch>
                <input
                  type="checkbox"
                  checked={addGstNumberChecked}
                  onChange={(e) => handleGstToggle(e.target.checked)}
                />
                <span />
              </ToggleSwitch>
            </WithoutPriceToggleWrapper>

            <WithoutPriceInfoBox>
              <Receipt size={18} color="#c94daa" />
              <span>
                {studioGstNumber
                  ? `Includes your studio's GSTIN (${studioGstNumber}) on this order.`
                  : "Includes your studio's GSTIN on this order (Add GST number in Profile)."}
              </span>
            </WithoutPriceInfoBox>
          </WithoutPriceBanner>

          <WithoutPriceBanner style={{ marginTop: "-8px" }}>
            <WithoutPriceToggleWrapper>
              <WithoutPriceText>Add Terms & Conditions</WithoutPriceText>
              <ToggleSwitch>
                <input
                  type="checkbox"
                  checked={addTermsChecked}
                  onChange={(e) => {
                    const nextVal = e.target.checked;
                    setAddTermsChecked(nextVal);
                    if (nextVal && !termsText && authBusiness?.terms_and_conditions) {
                      setTermsText(authBusiness.terms_and_conditions);
                    }
                  }}
                />
                <span />
              </ToggleSwitch>
            </WithoutPriceToggleWrapper>

            <WithoutPriceInfoBox>
              <FileText size={18} color="#c94daa" />
              <span>
                {addTermsChecked
                  ? "Terms & conditions will be included on the order document and PDF."
                  : "Exclude terms & conditions from this order."}
              </span>
            </WithoutPriceInfoBox>
          </WithoutPriceBanner>

          {addTermsChecked && (
            <div style={{ marginTop: "-8px", marginBottom: "20px", padding: "14px 16px", background: "#fafafa", borderRadius: "14px", border: "1px solid rgba(201, 77, 170, 0.16)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <span style={{ fontSize: "13px", fontWeight: 700, color: "#171717", fontFamily: "Montserrat, sans-serif" }}>
                  Terms & Conditions (Point by point)
                </span>
                {authBusiness?.terms_and_conditions && (
                  <button
                    type="button"
                    onClick={() => setTermsText(authBusiness.terms_and_conditions || "")}
                    style={{ background: "none", border: "none", color: "#c94daa", fontSize: "12px", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                  >
                    {!termsText ? "Load Studio Default Terms" : (termsText !== authBusiness.terms_and_conditions ? "Reset to Studio Default" : "")}
                  </button>
                )}
              </div>
              <textarea
                value={termsText}
                onChange={(e) => setTermsText(e.target.value)}
                placeholder="Enter terms and conditions (point by point)..."
                rows={4}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  borderRadius: "8px",
                  border: "1px solid rgba(23, 23, 23, 0.15)",
                  padding: "10px 12px",
                  fontSize: "13px",
                  fontFamily: "Montserrat, sans-serif",
                  lineHeight: "1.5",
                  color: "#171717",
                  background: "#ffffff",
                  resize: "vertical",
                  outline: "none"
                }}
              />
              <span style={{ fontSize: "11px", color: "rgba(23, 23, 23, 0.5)", marginTop: "4px", display: "block" }}>
                {authBusiness?.terms_and_conditions
                  ? "Pre-filled with your studio default terms. Edits made here apply only to this order."
                  : "Tip: You can set default terms for all documents anytime from the Orders toolbar."}
              </span>
            </div>
          )}

          <SectionHeading>
            <SectionIcon>
              <FileText size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Order basics</SectionHeadingTitle>
              <SectionHeadingSub>Number, date, and customer for this order</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>

          <RowGrid>
          <FormGroup>
            <FormLabel>Order No <Req>*</Req></FormLabel>
            <DisabledInput value={orderNo} readOnly />
          </FormGroup>
          <FormGroup>
            <FormLabel>Order Date <Req>*</Req></FormLabel>
            <DisabledInput value={orderDate} readOnly />
          </FormGroup>
          {branches && branches.length > 0 && (
            <FormGroup>
              <FormLabel>Branch (Optional)</FormLabel>
              <FormSelect value={selectedBranchId} onChange={(e) => setSelectedBranchId(e.target.value)}>
                <option value="">All Branches / Main Studio (HQ)</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.branch_name} {b.city ? `(${b.city})` : ''}
                  </option>
                ))}
              </FormSelect>
            </FormGroup>
          )}
          <FormGroup>
            <FormLabel>Customer <Req>*</Req></FormLabel>
            <FormSelect value={selectedCustIndex} onChange={handleCustChange}>
              <option value="custom">Search customer...</option>
              {dbCustomers.map((c) => (
                <option key={c.id} value={c.id}>{c.name} ({c.phone})</option>
              ))}
            </FormSelect>
          </FormGroup>
        </RowGrid>

        {selectedCustIndex === "custom" && (
          <ManualCustomerCard>
            <SectionHeading>
              <SectionIcon $tone="#0ea5e9">
                <Users size={20} />
              </SectionIcon>
              <SectionHeadingBody>
                <SectionHeadingTitle>Customer details</SectionHeadingTitle>
                <SectionHeadingSub>Manual entry when the customer is not in your list</SectionHeadingSub>
              </SectionHeadingBody>
            </SectionHeading>
            <RowGrid>
              <FormGroup>
                <FormLabel>Name</FormLabel>
                <TextInput placeholder="Enter name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
              </FormGroup>
              <FormGroup>
                <FormLabel>Mobile No</FormLabel>
                <PhoneInputRow>
                  <CountryCodeWrapper ref={countryDropdownRef} onClick={() => setIsCountryDropdownOpen((o) => !o)}>
                    <CountryCodeDisplay>
                      <CountryFlag>
                        {countryCodes.find((c) => c.code === countryCode)?.flag ?? "🌐"}
                      </CountryFlag>
                      <CountryCodeText>{countryCode}</CountryCodeText>
                      <CountryChevron>▼</CountryChevron>
                    </CountryCodeDisplay>
                    {isCountryDropdownOpen && (
                      <CountryDropdown onClick={(e) => e.stopPropagation()}>
                        <CountrySearchWrapper>
                          <CountrySearchInput
                            type="text"
                            placeholder="Search country..."
                            value={countrySearchQuery}
                            onChange={(e) => setCountrySearchQuery(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                          />
                        </CountrySearchWrapper>
                        <CountryList>
                          {countryCodes
                            .filter(
                              (c) =>
                                c.name.toLowerCase().includes(countrySearchQuery.toLowerCase()) ||
                                c.code.includes(countrySearchQuery)
                            )
                            .map((c) => (
                              <CountryListItem
                                key={`${c.name}-${c.code}`}
                                $active={countryCode === c.code}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCountryCode(c.code);
                                  setIsCountryDropdownOpen(false);
                                  setCountrySearchQuery("");
                                }}
                              >
                                <span style={{ fontSize: 16, marginRight: 8 }}>{c.flag}</span>
                                <span style={{ flex: 1, fontSize: 13, fontFamily: "Urbanist, sans-serif", color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</span>
                                <span style={{ fontSize: 13, fontFamily: "Urbanist, sans-serif", fontWeight: 600, color: "#c94daa", marginLeft: 8 }}>{c.code}</span>
                              </CountryListItem>
                            ))}
                        </CountryList>
                      </CountryDropdown>
                    )}
                  </CountryCodeWrapper>
                  <TextInput
                    placeholder="Enter mobile number"
                    value={customerPhone}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "").slice(0, 15);
                      setCustomerPhone(val);
                    }}
                  />
                </PhoneInputRow>
              </FormGroup>
              <FormGroup>
                <FormLabel>Place</FormLabel>
                <TextInput placeholder="Enter city/place" value={customerPlace} onChange={(e) => setCustomerPlace(e.target.value)} />
              </FormGroup>
            </RowGrid>
            <RowGrid style={{ marginTop: 12 }}>
              <FormGroup style={{ flex: 2 }}>
                <FormLabel>Address</FormLabel>
                <TextInput placeholder="Enter address" value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)} />
              </FormGroup>
              <FormGroup>
                <FormLabel>Reference</FormLabel>
                <TextInput placeholder="e.g. Google, Friend" value={customerReference} onChange={(e) => setCustomerReference(e.target.value)} />
              </FormGroup>
            </RowGrid>
          </ManualCustomerCard>
        )}
      </FormCard>

      {}
      <FormSplitLayout>
        <FormSplitLeft>
          <ComponentsSection style={{ margin: 0 }}>
            <ComponentsBar>
              <SectionHeading style={{ marginBottom: 0 }}>
                <SectionIcon>
                  <CheckSquare size={20} />
                </SectionIcon>
                <SectionHeadingBody>
                  <SectionHeadingTitle>Select components</SectionHeadingTitle>
                  <SectionHeadingSub>Toggle sections to include in this order</SectionHeadingSub>
                </SectionHeadingBody>
              </SectionHeading>
            </ComponentsBar>
            <VertCheckboxContainer>
              <CheckboxLabel>
                <input type="checkbox" checked={addEventsChecked} onChange={(e) => setAddEventsChecked(e.target.checked)} />
                Add Events
              </CheckboxLabel>
              <CheckboxLabel>
                <input type="checkbox" checked={addEventsResourcesChecked} onChange={(e) => setAddEventsResourcesChecked(e.target.checked)} />
                Add Events Resources
              </CheckboxLabel>
              <CheckboxLabel>
                <input type="checkbox" checked={addGiftsChecked} onChange={(e) => setAddGiftsChecked(e.target.checked)} />
                Add Special Gift Information
              </CheckboxLabel>
              <CheckboxLabel>
                <input type="checkbox" checked={addProductInfoChecked} onChange={(e) => setAddProductInfoChecked(e.target.checked)} />
                Add Product Information
              </CheckboxLabel>
              <CheckboxLabel>
                <input type="checkbox" checked={addAlbumChecked} onChange={(e) => setAddAlbumChecked(e.target.checked)} />
                Add Album Details
              </CheckboxLabel>
              <CheckboxLabel>
                <input type="checkbox" checked={addFixChargesChecked} onChange={(e) => setAddFixChargesChecked(e.target.checked)} />
                Add Fix Charges
              </CheckboxLabel>
            </VertCheckboxContainer>
          </ComponentsSection>
        </FormSplitLeft>
        <FormSplitRight>

      {/* Event Details */}
      {addEventsChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon>
              <Calendar size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Event details</SectionHeadingTitle>
              <SectionHeadingSub>Dates, times, and event types for this order</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <TableWrap>
            <DetailsTable>
              <thead>
                <tr>
                  <th style={{ width: 60 }}></th>
                  <th>Event Date</th>
                  <th>Event Time (Optional)</th>
                  <th>Event Type</th>
                </tr>
              </thead>
              <tbody>
                {eventRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <ActionGroup>
                        <TableAddButton type="button" onClick={addEventRow}><Plus size={14} /></TableAddButton>
                        <TableDeleteButton type="button" onClick={() => removeEventRow(idx)}><Trash2 size={14} /></TableDeleteButton>
                      </ActionGroup>
                    </td>
                    <td>
                      <BrandDatePicker
                        value={row.date || ""}
                        onChange={(v) => updateEventRow(idx, "date", v)}
                        disablePast
                        size="compact"
                        placeholder="dd/mm/yyyy"
                      />
                    </td>
                    <td>
                      <TableTimePickerWrapper>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={row.time && row.time !== "FULLDAY" && row.time !== "MORNING" && row.time !== "EVENING" ? dayjs(row.time, "hh:mm A") : null}
                            onChange={(e) => {
                              if (e && typeof e.isValid === "function" && e.isValid()) {
                                updateEventRow(idx, "time", e.format("hh:mm A"));
                              } else {
                                updateEventRow(idx, "time", "");
                              }
                            }}
                            slotProps={{
                              popper: {
                                strategy: "fixed"
                              },
                              paper: {
                                onWheel: (e: any) => e.stopPropagation(),
                                onTouchMove: (e: any) => e.stopPropagation(),
                              },
                              actionBar: {
                                actions: ["clear", "accept"],
                              },
                              field: {
                                clearable: true,
                                onClear: () => updateEventRow(idx, "time", ""),
                              },
                              textField: {
                                placeholder: "Optional",
                                onClick: (e: any) => {
                                  e.currentTarget.querySelector('button')?.click();
                                }
                              }
                            } as any}
                          />
                        </LocalizationProvider>
                      </TableTimePickerWrapper>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {hasMatchedInquiry && !row.isAddedRow ? (
                          <TableTextInput disabled value={row.type} style={{ background: '#f5f5f5', color: '#666', cursor: 'not-allowed' }} />
                        ) : (
                          <TableSelect
                            value={row.isCustomType ? "custom" : row.type}
                            onChange={(e) => {
                              const val = e.target.value;
                              updateEventRow(idx, "isCustomType", val === "custom");
                              if (val === "custom") {
                                updateEventRow(idx, "type", row.customTypeVal || "");
                              } else {
                                updateEventRow(idx, "type", val);
                              }
                            }}
                          >
                            <option value="custom">Custom (Enter Manually)...</option>
                            {dbEventTypes.map((et) => <option key={et.id} value={et.name}>{et.name}</option>)}
                          </TableSelect>
                        )}
                        {row.isCustomType && (
                          <TableTextInput
                            placeholder="Type custom event type..."
                            value={row.customTypeVal || ""}
                            onChange={(e) => {
                              updateEventRow(idx, "customTypeVal", e.target.value);
                              updateEventRow(idx, "type", e.target.value);
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </DetailsTable>
          </TableWrap>
        </SectionCard>
      )}

      {/* Resource Details */}
      {addEventsResourcesChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon $tone="#0ea5e9">
              <Users size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Resource details</SectionHeadingTitle>
              <SectionHeadingSub>Assign team members and products per event</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <TableWrap>
            <DetailsTable>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>Actions</th>
                  {!showResourceEventGroups && <th>Event</th>}
                  <th>Resources</th>
                  <th style={{ width: 120 }}>Quantity</th>
                  {!withoutPriceChecked && (
                    <>
                      <th style={{ width: 140 }}>Price (₹)</th>
                      <th style={{ width: 160 }}>Amount (₹)</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {resourceGroups.map((group) => (
                  <React.Fragment key={group.key}>
                    {group.label && (
                      <tr>
                        <ResourceEventGroupHeader colSpan={resourceColumnCount}>
                          <ResourceEventGroupHeaderInner>
                            <span>{group.label}</span>
                            <TableAddButton
                              type="button"
                              title="Add resource for this event"
                              onClick={() => addResourceRowForEvent(group.eventIndex)}
                            >
                              <Plus size={14} />
                            </TableAddButton>
                          </ResourceEventGroupHeaderInner>
                        </ResourceEventGroupHeader>
                      </tr>
                    )}
                    {group.indices.length === 0 && group.label && (
                      <tr>
                        <td colSpan={resourceColumnCount} style={{ color: "#888", fontSize: "13px", padding: "12px 16px" }}>
                          No resources yet — use + above to add resources for this event.
                        </td>
                      </tr>
                    )}
                    {group.indices.map((rowIdx) => {
                      const row = resourceRows[rowIdx];
                      return (
                        <tr key={rowIdx}>
                          <td>
                            <ActionGroup>
                              <TableDeleteButton type="button" onClick={() => removeResourceRow(rowIdx)}>
                                <Trash2 size={14} />
                              </TableDeleteButton>
                            </ActionGroup>
                          </td>
                          {!showResourceEventGroups && (
                            <td>
                              <TableSelect
                                value={row.eventIndex}
                                onChange={(e) => updateResourceRow(rowIdx, "eventIndex", e.target.value)}
                              >
                                <option value="all">All Events</option>
                                {eventRows.map((evt, eIdx) => (
                                  <option key={eIdx} value={String(eIdx)}>
                                    Event {eIdx + 1}: {evt.type || "Untitled"} ({evt.date || "No Date"})
                                  </option>
                                ))}
                              </TableSelect>
                            </td>
                          )}
                          <td>
                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                              <TableSelect
                                value={row.isCustomResource ? "custom" : row.resourceName}
                                onChange={(e) => updateResourceRow(rowIdx, "resourceName", e.target.value)}
                              >
                                <option value="custom">Custom (Enter Manually)...</option>
                                {resourceOptions.map((opt, oidx) => (
                                  <option key={oidx} value={opt.name}>
                                    {opt.name} ({opt.type})
                                  </option>
                                ))}
                              </TableSelect>
                              {row.isCustomResource && (
                                <TableTextInput
                                  placeholder="Type custom resource..."
                                  value={row.customResourceVal || ""}
                                  onChange={(e) => updateResourceRow(rowIdx, "customResourceVal", e.target.value)}
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <TableNumberInput
                              type="number"
                              min={1}
                              placeholder="Enter quantity"
                              value={row.quantity}
                              onChange={(e) =>
                                updateResourceRow(rowIdx, "quantity", e.target.value === "" ? "" : Number(e.target.value))
                              }
                            />
                          </td>
                          {!withoutPriceChecked && (
                            <>
                              <td>
                                <TableNumberInput
                                  type="number"
                                  min={0}
                                  placeholder="Enter Price"
                                  value={row.price}
                                  onChange={(e) =>
                                    updateResourceRow(rowIdx, "price", e.target.value === "" ? "" : Number(e.target.value))
                                  }
                                />
                              </td>
                              <td>
                                <DisabledInput
                                  style={{ margin: 0, height: 36 }}
                                  value={`₹${((Number(row.price) || 0) * (Number(row.quantity) || 0)).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                  })}`}
                                  readOnly
                                />
                              </td>
                            </>
                          )}
                        </tr>
                      );
                    })}
                    {!group.label && group.indices.length === 0 && (
                      <tr>
                        <td>
                          <ActionGroup>
                            <TableAddButton type="button" onClick={() => addResourceRowForEvent("all")}>
                              <Plus size={14} />
                            </TableAddButton>
                          </ActionGroup>
                        </td>
                        {!showResourceEventGroups && (
                          <td>
                            <TableSelect value="all" disabled onChange={() => {}}>
                              <option value="all">All Events</option>
                            </TableSelect>
                          </td>
                        )}
                        <td
                          colSpan={
                            showResourceEventGroups ? (withoutPriceChecked ? 2 : 4) : withoutPriceChecked ? 2 : 4
                          }
                          style={{ color: "#888", fontSize: "13px" }}
                        >
                          Click + to add a resource.
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </DetailsTable>
          </TableWrap>
        </SectionCard>
      )}

      {/* Conditional: Fix Charges Table */}
      {addFixChargesChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon $tone="#f59e0b">
              <IndianRupee size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Fix charges</SectionHeadingTitle>
              <SectionHeadingSub>Fixed fees applied to this order</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <TableWrap>
            <DetailsTable style={{ minWidth: withoutPriceChecked ? "100%" : "780px" }}>
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>Actions</th>
                  <th>Fix Charge</th>
                  <th style={{ width: "120px" }}>Quantity</th>
                  {!withoutPriceChecked && (
                    <>
                      <th style={{ width: "140px" }}>Price (₹)</th>
                      <th style={{ width: "160px" }}>Amount (₹)</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {fixChargeRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <ActionGroup>
                        <TableAddButton type="button" onClick={addFixChargeRow}>
                          <Plus size={14} />
                        </TableAddButton>
                        <TableDeleteButton type="button" onClick={() => removeFixChargeRow(idx)}>
                          <Trash2 size={14} />
                        </TableDeleteButton>
                      </ActionGroup>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <TableSelect
                          value={row.isCustomCharge ? "custom" : row.chargeName}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "custom") {
                              updateFixChargeRow(idx, "isCustomCharge", true);
                              updateFixChargeRow(idx, "chargeName", row.customChargeVal || "");
                            } else {
                              updateFixChargeRow(idx, "isCustomCharge", false);
                              updateFixChargeRow(idx, "chargeName", val);
                            }
                          }}
                        >
                          <option value="custom">Custom (Enter Manually)...</option>
                          {dbFixCharges.map((charge) => (
                            <option key={charge.id} value={charge.charge_name}>
                              {charge.charge_name} (₹{formatINR(charge.default_price)})
                            </option>
                          ))}
                        </TableSelect>
                        {row.isCustomCharge && (
                          <TableTextInput
                            type="text"
                            placeholder="Type custom fix charge name..."
                            value={row.customChargeVal || ""}
                            onChange={(e) => {
                              updateFixChargeRow(idx, "customChargeVal", e.target.value);
                              updateFixChargeRow(idx, "chargeName", e.target.value);
                            }}
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      <TableNumberInput
                        type="number"
                        min={1}
                        value={row.quantity}
                        onChange={(e) => updateFixChargeRow(idx, "quantity", Number(e.target.value) || 1)}
                      />
                    </td>
                    {!withoutPriceChecked && (
                      <>
                        <td>
                          <TableNumberInput
                            type="number"
                            min={0}
                            placeholder="Enter Price"
                            value={row.price}
                            onChange={(e) => updateFixChargeRow(idx, "price", Number(e.target.value) || 0)}
                          />
                        </td>
                        <td>
                          <DisabledInput
                            style={{ margin: 0, height: "36px" }}
                            value={`₹${((row.price || 0) * (row.quantity || 0)).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}`}
                            readOnly
                          />
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </DetailsTable>
          </TableWrap>
        </SectionCard>
      )}

      {/* Special Gift Information */}
      {addGiftsChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon $tone="#ec4899">
              <Gift size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Special gift information</SectionHeadingTitle>
              <SectionHeadingSub>Complimentary gifts included with the package</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <TableWrap>
            <DetailsTable style={{ minWidth: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 60 }}></th>
                  <th>Gift Item</th>
                  <th style={{ width: 120 }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {giftRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <ActionGroup>
                        <TableAddButton type="button" onClick={addGiftRow}><Plus size={14} /></TableAddButton>
                        <TableDeleteButton type="button" onClick={() => removeGiftRow(idx)}><Trash2 size={14} /></TableDeleteButton>
                      </ActionGroup>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        <TableSelect
                          value={row.isCustomGift ? "custom" : row.giftName}
                          onChange={(e) => {
                            const val = e.target.value;
                            updateGiftRow(idx, "isCustomGift", val === "custom");
                            if (val === "custom") {
                              updateGiftRow(idx, "giftName", row.customGiftVal || "");
                            } else {
                              updateGiftRow(idx, "giftName", val);
                            }
                          }}
                        >
                          <option value="custom">Custom (Enter Manually)...</option>
                          {staticGifts.map((g, gi) => <option key={gi} value={g}>{g}</option>)}
                        </TableSelect>
                        {row.isCustomGift && (
                          <TableTextInput
                            placeholder="Type custom gift item..."
                            value={row.customGiftVal || ""}
                            onChange={(e) => {
                              updateGiftRow(idx, "customGiftVal", e.target.value);
                              updateGiftRow(idx, "giftName", e.target.value);
                            }}
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      <TableNumberInput
                        type="number" min={1}
                        value={row.quantity}
                        onChange={(e) => updateGiftRow(idx, "quantity", e.target.value === "" ? "" : Number(e.target.value))}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </DetailsTable>
          </TableWrap>
        </SectionCard>
      )}

      {}
      {addProductInfoChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon $tone="#8b5cf6">
              <FileText size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Product information</SectionHeadingTitle>
              <SectionHeadingSub>Notes and description for deliverables</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <FormGroup>
            <FormLabel>Package Details &amp; Deliverables</FormLabel>
            <TextAreaInput
              rows={4}
              placeholder="Enter product description, special deliverables, guidelines..."
              value={productInfoDescription}
              onChange={(e) => setProductInfoDescription(e.target.value)}
            />
          </FormGroup>
        </SectionCard>
      )}

      {}
      {addAlbumChecked && (
        <SectionCard>
          <SectionHeading>
            <SectionIcon $tone="#14b8a6">
              <Layers size={20} />
            </SectionIcon>
            <SectionHeadingBody>
              <SectionHeadingTitle>Album details</SectionHeadingTitle>
              <SectionHeadingSub>Album type, size, paper, and page count</SectionHeadingSub>
            </SectionHeadingBody>
          </SectionHeading>
          <RowGrid>
            <FormGroup>
              <FormLabel>Album Type</FormLabel>
              <FormSelect
                value={isCustomAlbumType ? "custom" : albumType}
                onChange={(e) => {
                  const v = e.target.value;
                  setIsCustomAlbumType(v === "custom");
                  if (v !== "custom") setAlbumType(v);
                }}
              >
                <option value="custom">Custom (Enter Manually)...</option>
                {dbAlbumTypes.map((at) => <option key={at.id} value={at.name}>{at.name}</option>)}
              </FormSelect>
              {isCustomAlbumType && (
                <TextInput
                  style={{ marginTop: 6 }}
                  placeholder="Enter custom album type..."
                  value={customAlbumTypeVal}
                  onChange={(e) => { setCustomAlbumTypeVal(e.target.value); setAlbumType(e.target.value); }}
                />
              )}
            </FormGroup>
            <FormGroup>
              <FormLabel>Album Size (Width × Height, inches)</FormLabel>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <TextInput type="number" placeholder="Width"  value={albumWidth}  onChange={(e) => setAlbumWidth(Number(e.target.value) || 0)} />
                <SizeX>×</SizeX>
                <TextInput type="number" placeholder="Height" value={albumHeight} onChange={(e) => setAlbumHeight(Number(e.target.value) || 0)} />
              </div>
            </FormGroup>
          </RowGrid>
          <RowGrid style={{ marginTop: 14 }}>
            <FormGroup>
              <FormLabel>Album Paper</FormLabel>
              <FormSelect
                value={isCustomAlbumPaper ? "custom" : albumPaper}
                onChange={(e) => {
                  const v = e.target.value;
                  setIsCustomAlbumPaper(v === "custom");
                  if (v !== "custom") setAlbumPaper(v);
                }}
              >
                <option value="custom">Custom (Enter Manually)...</option>
                {dbAlbumPapers.map((ap) => <option key={ap.id} value={ap.name}>{ap.name}</option>)}
              </FormSelect>
              {isCustomAlbumPaper && (
                <TextInput
                  style={{ marginTop: 6 }}
                  placeholder="Enter custom album paper..."
                  value={customAlbumPaperVal}
                  onChange={(e) => { setCustomAlbumPaperVal(e.target.value); setAlbumPaper(e.target.value); }}
                />
              )}
            </FormGroup>
            <FormGroup>
              <FormLabel>Album Pages</FormLabel>
              <TextInput type="number" value={albumPages} onChange={(e) => setAlbumPages(Number(e.target.value) || 0)} />
            </FormGroup>
          </RowGrid>
        </SectionCard>
      )}

      <BottomSection>
        <BottomColumn>
          <SectionCard style={{ height: "100%" }}>
            <SectionHeading>
              <SectionIcon>
                <ClipboardList size={20} />
              </SectionIcon>
              <SectionHeadingBody>
                <SectionHeadingTitle>Optional services</SectionHeadingTitle>
                <SectionHeadingSub>Extra pages, video, and pad pricing add-ons</SectionHeadingSub>
              </SectionHeadingBody>
            </SectionHeading>
            <RowGrid style={{ marginTop: 12 }}>
              <FormGroup>
                <FormLabel>Album Extra Page Per Sheet (e.g. 11 × 22)</FormLabel>
                <TextInput placeholder="e.g. 12 x 18 Velvet Sheet" value={optAlbumPageCost} onChange={(e) => setOptAlbumPageCost(e.target.value)} />
              </FormGroup>
              <FormGroup>
                <FormLabel>Price (₹)</FormLabel>
                <TextInput type="number" placeholder="Enter Price" value={optAlbumPagePrice} onChange={(e) => setOptAlbumPagePrice(e.target.value === "" ? "" : String(Math.max(0, Number(e.target.value))))} />
              </FormGroup>
            </RowGrid>
            <RowGrid style={{ marginTop: 16 }}>
              <FormGroup>
                <FormLabel>Extra Video (e.g. Per Hour)</FormLabel>
                <TextInput placeholder="e.g. Extra Hour Raw Drone Footage" value={optVideoCost} onChange={(e) => setOptVideoCost(e.target.value)} />
              </FormGroup>
              <FormGroup>
                <FormLabel>Price (₹)</FormLabel>
                <TextInput type="number" placeholder="Enter Price" value={optVideoPrice} onChange={(e) => setOptVideoPrice(e.target.value === "" ? "" : String(Math.max(0, Number(e.target.value))))} />
              </FormGroup>
            </RowGrid>
            <FormGroup style={{ marginTop: 16 }}>
              <FormLabel>Album Pad Price Range</FormLabel>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <TextInput type="number" placeholder="Enter Price From" value={optPadPriceFrom} onChange={(e) => setOptPadPriceFrom(e.target.value === "" ? "" : String(Math.max(0, Number(e.target.value))))} />
                <SizeX>TO</SizeX>
                <TextInput type="number" placeholder="Enter Price To" value={optPadPriceTo} onChange={(e) => setOptPadPriceTo(e.target.value === "" ? "" : String(Math.max(0, Number(e.target.value))))} />
              </div>
            </FormGroup>
          </SectionCard>
        </BottomColumn>

        {!withoutPriceChecked && (
          <BottomColumn>
            <SectionCard style={{ height: "100%" }}>
              <SectionHeading>
                <SectionIcon $tone="#c94daa">
                  <Package size={20} />
                </SectionIcon>
                <SectionHeadingBody>
                  <SectionHeadingTitle>Totals &amp; pricing</SectionHeadingTitle>
                  <SectionHeadingSub>Discount, tax, and final grand total</SectionHeadingSub>
                </SectionHeadingBody>
              </SectionHeading>
              <FormGroup style={{ marginTop: 12 }}>
                <FormLabel>Total Amount (₹)</FormLabel>
                <DisabledInput value={pricing.totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })} readOnly />
              </FormGroup>
              <RowGrid style={{ marginTop: 12 }}>
                <FormGroup>
                  <FormLabel>Discount (%)</FormLabel>
                  <TextInput type="number" min={0} max={100} value={discountPercent} onChange={(e) => setDiscountPercent(e.target.value === "" ? "" : Number(e.target.value))} placeholder="Enter Discount" />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Discount Amount (₹)</FormLabel>
                  <DisabledInput value={pricing.discountAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })} readOnly />
                </FormGroup>
              </RowGrid>
              <FormGroup style={{ marginTop: 12 }}>
                <FormLabel>Subtotal (₹)</FormLabel>
                <DisabledInput value={pricing.subtotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })} readOnly />
              </FormGroup>
              <RowGrid style={{ marginTop: 12 }}>
                <FormGroup>
                  <FormLabel>Tax Percentage (%)</FormLabel>
                  <TextInput type="number" min={0} value={taxPercent} onChange={(e) => setTaxPercent(e.target.value === "" ? "" : Number(e.target.value))} placeholder="Enter Tax" />
                </FormGroup>
                <FormGroup>
                  <FormLabel>Tax Amount (₹)</FormLabel>
                  <DisabledInput value={pricing.taxAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })} readOnly />
                </FormGroup>
              </RowGrid>
              <FormGroup style={{ marginTop: 16 }}>
                <FormLabel style={{ fontSize: 14, fontWeight: 700 }}>Grand Total (₹)</FormLabel>
                <GrandTotalDisplay>
                  ₹{pricing.grandTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </GrandTotalDisplay>
              </FormGroup>

              {/* Extra checkboxes — Order-specific */}
              <BottomCheckboxes>
                <CheckboxLabel>
                  <input type="checkbox" checked={advancePaymentChecked} onChange={(e) => setAdvancePaymentChecked(e.target.checked)} />
                  Any Advance Payment
                </CheckboxLabel>
                <CheckboxLabel>
                  <input type="checkbox" checked={whatsappConfirmChecked} onChange={(e) => setWhatsappConfirmChecked(e.target.checked)} />
                  Send Whatsapp Confirmation to Customer
                </CheckboxLabel>
              </BottomCheckboxes>
            </SectionCard>
          </BottomColumn>
        )}

        {withoutPriceChecked && (
          <BottomColumn>
            <SectionCard style={{ height: "100%" }}>
              <SectionHeading>
                <SectionIcon $tone="#6366f1">
                  <CheckSquare size={20} />
                </SectionIcon>
                <SectionHeadingBody>
                  <SectionHeadingTitle>Order options</SectionHeadingTitle>
                  <SectionHeadingSub>Advance payment and customer notifications</SectionHeadingSub>
                </SectionHeadingBody>
              </SectionHeading>
              <BottomCheckboxes style={{ marginTop: 16 }}>
                <CheckboxLabel>
                  <input type="checkbox" checked={advancePaymentChecked} onChange={(e) => setAdvancePaymentChecked(e.target.checked)} />
                  Any Advance Payment
                </CheckboxLabel>
                <CheckboxLabel>
                  <input type="checkbox" checked={whatsappConfirmChecked} onChange={(e) => setWhatsappConfirmChecked(e.target.checked)} />
                  Send Whatsapp Confirmation to Customer
                </CheckboxLabel>
              </BottomCheckboxes>
            </SectionCard>
          </BottomColumn>
        )}
      </BottomSection>
    </FormSplitRight>
  </FormSplitLayout>

      <EndFooter>
        <SubmitHint>
          {withoutPriceChecked
            ? "Prices are hidden. Review details, then save this order."
            : "Review sections and pricing, then save this order."}
        </SubmitHint>
        <SaveButton onClick={handleSave} disabled={isSaving}>
          <Save size={18} />
          {isSaving ? "Saving..." : "Save Order"}
        </SaveButton>
      </EndFooter>
      </FormScrollContainer>
    </PageContainer>
  );
};

export default CreateOrderForm;

// ── Country Code Dropdown Styles (mirrors LoginForm) ──────────────────────────

const PhoneInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CountryCodeWrapper = styled.div`
  position: relative;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
`;

const CountryCodeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 42px;
  padding: 0 10px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  border-radius: 10px;
  background: #ffffff;
  font-family: Montserrat, sans-serif;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.45);
  }
`;

const CountryFlag = styled.span`
  font-size: 18px;
  line-height: 1;
`;

const CountryCodeText = styled.span`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Urbanist', sans-serif;
  color: #171717;
  min-width: 38px;
`;

const CountryChevron = styled.span`
  font-size: 10px;
  color: #555;
  margin-left: 2px;
`;

const CountryDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 280px;
  max-height: 250px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 200;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ccFadeIn 0.15s ease-out;

  @keyframes ccFadeIn {
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const CountrySearchWrapper = styled.div`
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  background: #ffffff;
`;

const CountrySearchInput = styled.input`
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
  font-family: 'Urbanist', sans-serif;
  outline: none;
  box-sizing: border-box;
  &:focus { border-color: #c94daa; }
`;

const CountryList = styled.div`
  overflow-y: auto;
  flex: 1;
  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-track { background: #f1f1f1; }
  &::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
`;

const CountryListItem = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  background-color: ${(p) => (p.$active ? "#f9ecf7" : "transparent")};
  &:hover { background-color: #f3f4f6; }
`;

const FormSplitLayout = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 20px;
  align-items: start;
  margin-top: 4px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const FormSplitLeft = styled.div`
  position: sticky;
  top: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 5;

  @media (max-width: 1024px) {
    position: static;
  }
`;

const FormSplitRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

const VertCheckboxContainer = styled.div`
  padding: 4px 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ResourceEventGroupHeader = styled.td`
  background: linear-gradient(135deg, rgba(201, 77, 170, 0.06), rgba(255, 201, 81, 0.08));
  border-top: 1px solid rgba(201, 77, 170, 0.12);
  border-bottom: 1px solid rgba(201, 77, 170, 0.1);
  padding: 10px 16px !important;
  font-weight: 700;
  font-size: 13px;
  color: #171717;
`;

const ResourceEventGroupHeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
